const o="support-area";export{o as SUPPORT_AREA};
